import React, { useEffect, useRef, useState } from "react"
import Breadcrumbs from "../../../components/Common/Breadcrumb"
import { Col, Row, Card, UncontrolledPopover, PopoverBody } from "reactstrap"
import UpdateTable from "../../../components/Common/UpdatedTable"
import action from "../../../assets/icons/action.svg"
import { toastSuccess } from "../../../helpers/msg_helper"
import SupplierFilter from "./filter"
import { Link, useLocation, useNavigate } from "react-router-dom"
import { hrmsEosUpdateStatus, searchHrmsEos } from "../../../services/Hrms/hrms"

const EndOfService = () => {
  const companyname = localStorage.getItem('companyname')
  document.title = `Final Settlements${companyname ? ` | ${companyname}` : 'MEP -Hub'}`;

  const locations = useLocation();
  const crumb = locations?.state?.menuLabel || ""

  const navigate = useNavigate()
  const [refresh, setRefresh] = useState(0)
  const [classData, setClassData] = useState()
  const [status, setStatus] = useState("")
  const [search, setSearch] = useState("")
  const [empCode, setEmpCode] = useState("")
  const [page, setPage] = useState("")
  const [financial, setFinancial] = useState(true)
  const [dataPerPage, setDataPerPage] = useState(25)
  const [isLoadingNextPage, setIsLoadingNextPage] = useState(false)

  const handleActivate = item => {
    const updateStatus = async item => {
      const response = await hrmsEosUpdateStatus(item)
      toastSuccess(response?.message)
      setRefresh(refresh + 1)
    }
    updateStatus(item)
  }

  const handleSizePerPageChange = size => {
    setDataPerPage(size)
  }

  const columns = [
    {
      label: "Code",
      renderCell: item => {
        return (
          <>
            <div
              onClick={() =>
                navigate(`/hrms-final-settlement/view/${item?.id}`)
              }
              className="pointer fw-bold"
            >
              {item?.code}
            </div>
          </>
        )
      },
    },
    {
      label: "Employee Code",
      renderCell: item => (
        <div className="capitalize-letter">{item?.employee?.employee_code}</div>
      ),
      sortKey: "first_name",
    },
    {
      label: "Employee Name",
      renderCell: item => (
        <div className="capitalize-letter">{item?.employee?.first_name}</div>
      ),
      sortKey: "first_name",
    },
    {
      label: "End of Duty",
      renderCell: item => (
        <div className="capitalize-letter">{item?.eod ? item?.eod : "-"}</div>
      ),
    },
    {
      label: "Type",
      renderCell: item => (
        <div className="capitalize-letter">{item?.type ? item?.type : "-"}</div>
      ),
    },
    {
      label: "Description",
      renderCell: item => (
        <div className="capitalize-letter">{item?.description}</div>
      ),
    },
    {
      label: "Status",
      renderCell: item => (
        <div>
          <span
            className={`font-13 ${item?.status === 1 ? "status-active" : "status-inactive"
              }`}
          >
            {item?.status === 1 ? "Approve" : "Draft"}
          </span>
        </div>
      ),
    },
    {
      label: "Action",
      renderCell: item => (
        <>
          <div>
            <span id={`PopoverLegacy-${item?.id}`}>
              <img src={action} alt="" className="pointer" />
            </span>
          </div>
          <UncontrolledPopover
            placement="bottom"
            target={`PopoverLegacy-${item?.id}`}
            trigger="legacy"
          >
            <PopoverBody>
              <>
                <div
                  className={` table-popup-content`}
                  onClick={() =>
                    navigate(`/hrms-final-settlement/view/${item?.id}`)
                  }
                >
                  View
                </div>
                {item?.status != 1 ? (
                  <>
                    <div
                      className={` table-popup-content`}
                      onClick={() =>
                        navigate(`/hrms-final-settlement/edit/${item?.id}`)
                      }
                    >
                      Edit
                    </div>
                    <div
                      className={`table-popup-content`}
                      onClick={() => handleActivate(item?.id)}
                    >
                      {item?.status === 1 ? "Deactivate" : "Approve"}
                    </div>
                  </>
                ) : (
                  <></>
                )}
              </>
            </PopoverBody>
          </UncontrolledPopover>
        </>
      ),
    },
  ]

  const handlePaginate = page => {
    setPage(page)
  }

  useEffect(() => {
    const fetchClass = async () => {
      const response = await searchHrmsEos({
        params: `${status == "0" || status == "1" ? `&status=${status}` : ""}${search ? `&searchText=${search}` : "&searchText"
          }${`&sortOrder=asc`}${page ? `&page=${page}` : ""}${empCode ? `&emp_id=${empCode}` : ""
          }${dataPerPage ? `&sizePerPage=${dataPerPage}` : ""}`,
      })
      // setClassData(response)
      const newData = response?.data?.data || [];

      setClassData(prev =>
        page > 1 && prev
          ? {
            ...response,
            data: {
              ...response.data,
              data: [...(prev.data?.data || []), ...newData],
            },
          }
          : response
      );
      setIsLoadingNextPage(response == undefined ? true : false)
      isLoadingRef.current = false;
    }
    fetchClass()
    // ${`&financial=${financial}`}
  }, [refresh, status, search, empCode, page, financial, dataPerPage])

  const tableContainerRef = useRef(null)
  const isLoadingRef = useRef(false);
  const scrollTimeoutRef = useRef(null);

  useEffect(() => {
    const handleScroll = (e) => {
      const { scrollTop, scrollHeight, clientHeight } = e.target;
      
      if (scrollTimeoutRef.current) {
        clearTimeout(scrollTimeoutRef.current);
      }
      
      scrollTimeoutRef.current = setTimeout(() => {
        if (
          scrollTop + clientHeight >= scrollHeight - 50 &&
          !isLoadingRef.current &&
          page < classData?.data?.last_page
        ) {
          isLoadingRef.current = true;
          setIsLoadingNextPage(true);
          setPage(prev => prev + 1);
        }
      }, 200);
    };
    
    const container = tableContainerRef.current;
    if (container) {
      container.addEventListener("scroll", handleScroll);
    }
    
    return () => {
      if (container) {
        container.removeEventListener("scroll", handleScroll);
      }
      if (scrollTimeoutRef.current) {
        clearTimeout(scrollTimeoutRef.current);
      }
    };
  }, [classData, page]);

  const handleStatusChange = id => {
    setStatus(id)
    setPage(1)
  }
  const handleEmployeeChange = id => {
    setEmpCode(id)
    setPage(1)
  }
  const handleSearchChange = data => {
    setSearch(data)
    setPage(1)
  }

  const handleFinacialChange = id => {
    setFinancial(id)
    setPage(1)
  }
  return (
    <React.Fragment>
      <div className="page-content">
        <div className="container-fluid">
          <div className="d-flex justify-content-between">
            <Breadcrumbs
              title="HRMS"
              breadcrumbObject={[
                { title: "HRMS", link: "/hrms" },
                { title: crumb || "HRMS", link: "/hrms" },
                { title: "Final Settlements", link: "/hrms-final-settlement" },
              ]}
            />
            <Link
              to="/hrms-final-settlement/add"
              state={{ menuLabel: crumb }}
              className={"px-2 mb-3 me-2 btn btn-primary"}
            >
              {"+ Final Settlement"}
            </Link>
          </div>
          <Card className="me-2 px-2 pb-2">
            <SupplierFilter
              handleStatusChange={handleStatusChange}
              handleSearchChange={handleSearchChange}
              handleEmployeeChange={handleEmployeeChange}
              handleFinacialChange={handleFinacialChange}
              sampleUrl={"download/employee.xlsx"}
              importUrl={"/employee-details/import-employees"}
              isImport={false}
            />
            <hr className="table-divide" />
            <Row className="mt-2 ever-rise-table">
              <Col xs={12}>
              <div ref={tableContainerRef} style={{ maxHeight: "490px", overflowY: "auto" }}>
                {classData && (
                  <UpdateTable
                    className="mt-5"
                    nodes={classData?.data?.data}
                    paginate={classData?.data}
                    columns={columns}
                    CurrentPage={page}
                    handlePagination={handlePaginate}
                    handleSizePerPage={handleSizePerPageChange}
                    tableWidth="15% 15% 15% 15% 10% 10% 10% 10%"
                    isLoading={isLoadingNextPage}
                    hidePaginate={true}
                  />
                )}
                </div>
              </Col>
            </Row>
          </Card>
        </div>
      </div>
    </React.Fragment>
  )
}

export default EndOfService
